// The only way the viewer talks to the rail: openapi-fetch typed by the
// generated contract (schema.d.ts, from backend/passport-api/openapi/passport-api.yaml).
import createClient from "openapi-fetch";
import type { components, paths } from "./schema";

export type Schemas = components["schemas"];
export type ClaimView = Schemas["ClaimView"];
export type VouchView = Schemas["VouchView"];
export type Anchor = Schemas["Anchor"];
export type Rung = Schemas["Rung"];
export type RegisteredIssuer = Schemas["RegisteredIssuer"];
export type InclusionProof = Schemas["InclusionProof"];

/** VITE_API_BASE: where the rail API is mounted; default /rail-api, which nginx (deploy) and the mock proxy to the API. */
export const apiBase: string = (import.meta.env?.VITE_API_BASE as string | undefined) ?? "/rail-api";

// fetch is looked up per call (not captured at load), so tests can stub it.
// A relative base is resolved against the page's origin (absolute for every runtime's Request).
const base = apiBase.startsWith("/") && typeof location !== "undefined" && location.origin !== "null" ? location.origin + apiBase : apiBase;
export const api = createClient<paths>({ baseUrl: base, fetch: (input: Request) => globalThis.fetch(input) });

/** Unwrap an openapi-fetch result, throwing the problem detail on error. */
export async function must<T>(p: Promise<{ data?: T; error?: unknown; response: Response }>): Promise<T> {
  const r = await p;
  if (r.data !== undefined && r.response.ok) return r.data;
  const e: any = r.error;
  throw new ApiError(r.response.status, e?.detail ?? e?.error ?? e?.title ?? r.response.statusText, e?.type);
}

export class ApiError extends Error {
  constructor(public status: number, message: string, public type?: string) { super(message); }
}
